import DemographicTab from './DemographicTab.tsx';

export default DemographicTab;
